import * as React from "react";
import Flag from "react-world-flags";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import FallBackImage from "../FallBackImage";
import { Plug } from "../Icons";
import { useImageSrc } from "../../hooks";
import { IMAGES } from "../../themes";
const useStyles = makeStyles(({
  typography
}) => ({
  container: {
    position: "relative",
    lineHeight: 0,
    marginTop: typography.pxToRem(15)
  },
  photo: {
    maxHeight: "6.125rem",
    borderRadius: "50%",
    width: "6.125rem"
  },
  flag: {
    position: "absolute",
    transform: "translate(50%, 0.5625rem)",
    top: 0,
    right: 0
  },
  electricIcon: {
    transform: "rotate(180deg)",
    position: "absolute",
    bottom: typography.pxToRem(-7),
    left: typography.pxToRem(85)
  },
  fallBack: {
    border: "0.5px solid rgba(0, 0, 0, 0.4)"
  }
}));

const PhotoWithFlag = ({
  photo,
  className,
  country,
  isVehicleElectric
}) => {
  const styles = useStyles();
  const fallBackSrc = useImageSrc(IMAGES.DRIVER);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className)
  }, /*#__PURE__*/React.createElement(FallBackImage, {
    src: photo,
    fallBackSrc: fallBackSrc,
    fallBackStyles: styles.fallBack,
    className: styles.photo,
    alt: "driver photo"
  }), country && /*#__PURE__*/React.createElement(Flag, {
    className: styles.flag,
    code: country,
    height: "26"
  }), isVehicleElectric && window.matchMedia("(min-width: 960px)").matches && /*#__PURE__*/React.createElement(Plug, {
    className: styles.electricIcon,
    style: {
      width: "53px",
      height: "26px"
    }
  }));
};

export default PhotoWithFlag;